import { render, staticRenderFns } from "./ESG.vue?vue&type=template&id=31cb4e88"
import script from "./ESG.vue?vue&type=script&lang=js"
export * from "./ESG.vue?vue&type=script&lang=js"
import style0 from "./ESG.vue?vue&type=style&index=0&id=31cb4e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports